import {
  Box, Flex, Heading, Button, useToast, Spinner, Text, Tooltip, Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Divider,
  Select,
  Badge
} from '@chakra-ui/react'
import React, { Fragment, useEffect, useState } from 'react'
import AdditionalDetails from '../../component/AdditionalDetails'
import RightSidebar from '../../component/RightSidebar'
// import Timeline from '../../component/Timeline'
import DocumentAttached from '../../component/DocumentAttached'
import CustomerDetails from '../../component/CustomerDetails'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { BiArrowBack } from 'react-icons/bi';
import { AiOutlineDown } from "react-icons/ai";
import axios from 'axios'
import { Auth } from '../../component/Auth'
import PanVerification from './PanVerification'

const VerifcationDetails = () => {
  const [adData, setAdData] = useState({})
  const [orderData, setOrderData] = useState({})
  const [verificationToggle, setVerificationToggle] = useState(false)
  const [isVerified, setIsVerified] = useState(false)
  const [renderOnCredit, setRenderOnCredit] = useState(0)
  const [journeyDetails, setJourneyDetails] = useState([])
  const [customerJourneyDetails, setCustomerJourneyDetails] = useState([])
  const [finboxManualData, setFinboxManualData] = useState({
    kycCategory: '',
    response: {}
  })
  const [finboxToggle, setFinboxToggle] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [gstInfo, setGstInfo] = useState([])
  const [dinInfo, setDinInfo] = useState([])
  // const [panDetailsToggle, setPanDetailsToggle] = useState(false)
  const [isOpen1, setIsOpen1] = useState(false)
  const [isOpen2, setIsOpen2] = useState(false)
  const [isOpen3, setIsOpen3] = useState(false)
  const [isOpen4, setIsOpen4] = useState(false)

  const onClose1 = () => setIsOpen1(false)
  const onOpen1 = () => setIsOpen1(true)
  const onClose2 = () => setIsOpen2(false)
  const onClose3 = () => setIsOpen3(false)
  const onClose4 = () => setIsOpen4(false)
  const onOpen2 = () => setIsOpen2(true)
  const onOpen3 = () => setIsOpen3(true)
  const onOpen4 = () => setIsOpen4(true)
  const { id } = useParams()
  const navigate = useNavigate()
  const toast = useToast()


  // get order by id
  useEffect(() => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/${id}`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': Auth()
      },
    };
    axios.request(config)
      .then((response) => {
        setOrderData(response.data)
        let partyId = response.data.enteredByPartyId

        // fetching all tenure details ------------
        let config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_RALCO_API_URL}/api/party/${partyId}`,
          headers: {
            'Authorization': Auth()
          }
        };

        axios.request(config)
          .then((response) => {
            setAdData(response.data)
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id, verificationToggle, renderOnCredit])

  // Customer Verification Handler
  const verifyHandler = () => {


    let data = JSON.stringify({
      "orderStatusId": `ORDER_VERIFIED`
    });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/${id}`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': Auth()
      },
      data: data
    };

    axios.request(config)
      .then(() => {
        setVerificationToggle(true)
        // setPanDetailsToggle(true)
        setIsVerified(true)
        toast({
          title: `Customer verification done`,
          status: 'success',
          duration: 4000,
          isClosable: true,
          position: 'top'
        })

        // ################# AFTER VERIFICATION DONE GENERATE VERIFICATION DONE TICKET ###########################
        // GET TICKET
        if (orderData?.orderStatusId === "AWAITING_VERIFICATION") { // Ticket Updation for awaiting verification

          // let getTicket = {
          //   method: 'get',
          //   maxBodyLength: Infinity,
          //   url: `${process.env.REACT_APP_RALCO_API_URL}/api/freshdesk/get-ticket-with-order-id/${id}`,
          //   headers: {
          //     'Content-Type': 'application/json',
          //     'Authorization': Auth()
          //   },
          // };

          // axios.request(getTicket)
          //   .then((response) => {
          //     // console.log(JSON.stringify(response.data));
          //     const data = response.data
          //     let ticketObj = data.filter((x) => ((x.shopifyOrderId === id) && (x.ticketObj.custom_fields.cf_ticket_type === "CUSTOMER_VERIFICATION_TICKET") && (x.ticketObj.custom_fields.cf_status === "VERIFICATION_REQUEST_SUBMITTED")))
          //     let ticketId = ticketObj[0].ticketId

          //     let myPayload = JSON.stringify({
          //       "shopifyOrderId": `{id}`,
          //       "tenureId": null,
          //       "extraData": null,
          //       "freshdesk": {
          //         "custom_fields": {
          //           "cf_ticket_type": "CUSTOMER_VERIFICATION_TICKET",
          //           "cf_status": "VERIFIED_SUCCESSFULLY"
          //         }
          //       }
          //     });
          //     // Update Ticket
          //     let config = {
          //       method: 'put',
          //       maxBodyLength: Infinity,
          //       url: `${process.env.REACT_APP_RALCO_API_URL}/api/freshdesk/update-ticket/${ticketId}`,
          //       headers: {
          //         'Content-Type': 'application/json',
          //         'Authorization': Auth()
          //       },
          //       data: myPayload
          //     };

          //     axios.request(config)
          //       .then((response) => {
          //         // console.log(JSON.stringify(response.data));
          //         console.log('Ticket Update Successfullyyy --- VERIFIED #####################################')
          //       })
          //       .catch((error) => {
          //         console.log(error);
          //       });


          //   })
          //   .catch((error) => {
          //     console.log(error);
          //   });
        } else if (orderData?.orderStatusId === "ORDER_CREATED") {  //  ### TICKET UPDATION FOR CREATED ORDER -- BYPAASS VERIFICATION ###
          // let getTicket = {
          //   method: 'get',
          //   maxBodyLength: Infinity,
          //   url: `${process.env.REACT_APP_RALCO_API_URL}/api/freshdesk/get-ticket-with-order-id/${id}`,
          //   headers: {
          //     'Content-Type': 'application/json',
          //     'Authorization': Auth()
          //   },
          // };

          // axios.request(getTicket)
          //   .then((response) => {
          //     // console.log(JSON.stringify(response.data));
          //     const data = response.data
          //     let ticketObj = data.filter((x) => ((x.shopifyOrderId === id) && (x.ticketObj.custom_fields.cf_ticket_type === "ORDER_TICKET") && (x.ticketObj.custom_fields.cf_status === "ORDER_PLACED")))
          //     let ticketId = ticketObj[0].ticketId

          //     let myPayload = JSON.stringify({
          //       "shopifyOrderId": `{id}`,
          //       "tenureId": null,
          //       "extraData": null,
          //       "freshdesk": {
          //         "custom_fields": {
          //           "cf_ticket_type": "CUSTOMER_VERIFICATION_TICKET",
          //           "cf_status": "VERIFIED_SUCCESSFULLY"
          //         }
          //       }
          //     });
          //     // Update Ticket
          //     let config = {
          //       method: 'put',
          //       maxBodyLength: Infinity,
          //       url: `${process.env.REACT_APP_RALCO_API_URL}/api/freshdesk/update-ticket/${ticketId}`,
          //       headers: {
          //         'Content-Type': 'application/json',
          //         'Authorization': Auth()
          //       },
          //       data: myPayload
          //     };

          //     axios.request(config)
          //       .then((response) => {
          //         // console.log(JSON.stringify(response.data));
          //         console.log('Ticket Update Successfullyyy --- VERIFIED #####################################')
          //       })
          //       .catch((error) => {
          //         console.log(error);
          //       });


          //   })
          //   .catch((error) => {
          //     console.log(error);
          //   });
        }

      })
      .catch((error) => {
        console.log('error when verify customer');
        setVerificationToggle(false)
        setIsVerified(true)
        toast({
          title: `Something went wrong please try again`,
          status: 'error',
          duration: 4000,
          isClosable: true,
          position: 'top'
        })
      });
  }


  //  ##### decline handler onClick #########
  const declineHandler = () => {
    let data = JSON.stringify({
      "orderStatusId": `ORDER_CANCELED`
    });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/${id}`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': Auth()
      },
      data: data
    };

    axios.request(config)
      .then(() => {
        setVerificationToggle(true)
        // setPanDetailsToggle(true)
        setIsVerified(true)
        toast({
          title: `Customer verification denied`,
          status: 'error',
          duration: 4000,
          isClosable: true,
          position: 'top'
        })

        // ################# AFTER VERIFICATION DONE GENERATE VERIFICATION DENIED TICKET ###########################
        // GET TICKET
        // if (orderData?.orderStatusId === "AWAITING_VERIFICATION") { // Ticket Updation for awaiting verification
        //   let getTicket = {
        //     method: 'get',
        //     maxBodyLength: Infinity,
        //     url: `${process.env.REACT_APP_RALCO_API_URL}/api/freshdesk/get-ticket-with-order-id/${id}`,
        //     headers: {
        //       'Content-Type': 'application/json',
        //       'Authorization': Auth()
        //     },
        //   };

        //   axios.request(getTicket)
        //     .then((response) => {
        //       // console.log(JSON.stringify(response.data));
        //       const data = response.data
        //       let ticketObj = data.filter((x) => ((x.shopifyOrderId === id) && (x.ticketObj.custom_fields.cf_ticket_type === "CUSTOMER_VERIFICATION_TICKET") && (x.ticketObj.custom_fields.cf_status === "VERIFICATION_REQUEST_SUBMITTED")))
        //       let ticketId = ticketObj[0].ticketId

        //       let myPayload = JSON.stringify({
        //         "shopifyOrderId": `{id}`,
        //         "tenureId": null,
        //         "extraData": null,
        //         "freshdesk": {
        //           "custom_fields": {
        //             "cf_ticket_type": "CUSTOMER_VERIFICATION_TICKET",
        //             "cf_status": "VERIFICATION_DENIED"
        //           }
        //         }
        //       });
        //       // Update Ticket
        //       let config = {
        //         method: 'put',
        //         maxBodyLength: Infinity,
        //         url: `${process.env.REACT_APP_RALCO_API_URL}/api/freshdesk/update-ticket/${ticketId}`,
        //         headers: {
        //           'Content-Type': 'application/json',
        //           'Authorization': Auth()
        //         },
        //         data: myPayload
        //       };

        //       axios.request(config)
        //         .then((response) => {
        //           // console.log(JSON.stringify(response.data));
        //           console.log('Ticket Update Successfullyyy -- DECLINED #####################################')
        //         })
        //         .catch((error) => {
        //           console.log(error);
        //         });
        //     })
        // } else if (orderData?.orderStatusId === "ORDER_CREATED") {  //  ### TICKET UPDATION FOR CREATED ORDER -- BYPAASS VERIFICATION ###
        //   let getTicket = {
        //     method: 'get',
        //     maxBodyLength: Infinity,
        //     url: `${process.env.REACT_APP_RALCO_API_URL}/api/freshdesk/get-ticket-with-order-id/${id}`,
        //     headers: {
        //       'Content-Type': 'application/json',
        //       'Authorization': Auth()
        //     },
        //   };

        //   axios.request(getTicket)
        //     .then((response) => {
        //       // console.log(JSON.stringify(response.data));
        //       const data = response.data
        //       let ticketObj = data.filter((x) => ((x.shopifyOrderId === id) && (x.ticketObj.custom_fields.cf_ticket_type === "ORDER_TICKET") && (x.ticketObj.custom_fields.cf_status === "ORDER_PLACED")))
        //       let ticketId = ticketObj[0].ticketId

        //       let myPayload = JSON.stringify({
        //         "shopifyOrderId": `{id}`,
        //         "tenureId": null,
        //         "extraData": null,
        //         "freshdesk": {
        //           "custom_fields": {
        //             "cf_ticket_type": "CUSTOMER_VERIFICATION_TICKET",
        //             "cf_status": "VERIFICATION_DENIED"
        //           }
        //         }
        //       });
        //       // Update Ticket
        //       let config = {
        //         method: 'put',
        //         maxBodyLength: Infinity,
        //         url: `${process.env.REACT_APP_RALCO_API_URL}/api/freshdesk/update-ticket/${ticketId}`,
        //         headers: {
        //           'Content-Type': 'application/json',
        //           'Authorization': Auth()
        //         },
        //         data: myPayload
        //       };

        //       axios.request(config)
        //         .then((response) => {
        //           // console.log(JSON.stringify(response.data));
        //           console.log('Ticket Update Successfullyyy --- DECLINED #####################################')
        //         })
        //         .catch((error) => {
        //           console.log(error);
        //         });


        //     })
        //     .catch((error) => {
        //       console.log(error);
        //     });
        // }

      })

      .catch((error) => {
        console.log('error when verify customer');
        setVerificationToggle(false)
        setIsVerified(true)
        toast({
          title: `Something went wrong please try again`,
          status: 'error',
          duration: 4000,
          isClosable: true,
          position: 'top'
        })
      });
  }

  // ### JOURNEY ORDER ###
  useEffect(() => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/basic/order-journey?orderId=${id}`,
      headers: {}
    };

    axios.request(config)
      .then((response) => {
        setJourneyDetails(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id])

  // ## JOURNEY CUSTOMER ##
  useEffect(() => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/basic/order-journey?partyId=${orderData?.customerPartyId}`,
      headers: {}
    };

    axios.request(config)
      .then((response) => {
        setCustomerJourneyDetails(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
      console.log(orderData, 'orderData');
  }, [orderData])

  // console.log(Object.keys(adData).length > 0 ? adData.PartyPanKyc.find((x) => x.kycCategory === adData?.PartyFaceMatch.find((x) => x.verificationId === orderData?.id).kycCategory) : 'null', 'zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzz')

  // console.log(orderData.OrderPartyBankStatement[0].kycCategory)

  // call partyDetails on credit report download successfully
  const renderXyz = () => {
    setRenderOnCredit((prev) => renderOnCredit + 1)
  }

  // Format Date ----
  const formatDate = (date) => {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };
    const dateString = date.toLocaleDateString("en-US", options);
    const timeString = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
    return `${dateString}, ${timeString}`
  }

  // GST DETAILS ### DECENTRO
  useEffect(() => {
    // GST
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/decentro/get-order-gst-report?orderId=${id}`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': Auth()
      },
    };
    axios.request(config)
      .then((response) => {
        setGstInfo(response.data)

      })
      .catch((error) => {
        console.log(error);
      });



  }, [id])

  useEffect(() => {
    // DIN
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/decentro/get-order-din-report?orderId=${id}`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': Auth()
      },
    };

      axios.request(config)
        .then((response) => {
          setDinInfo(response.data)
        })
        .catch((error) => {
          console.log(error);
        });
    
  }, [id])

  // ### GET PROFESSION ###
  const getProfession = () => {
    setBtnLoading(true)
    setFinboxToggle(false)
    const allProfession = ['PVT_LTD','STUDENT','PARTNERSHIP','WORK_PROF']
    for(let i = 0; i < allProfession.length ; i++){
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_RALCO_API_URL}/api/finbox/manual/fetch-webhook?linkId=${id}@@@${allProfession[i]}`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': Auth()
        },
      };
      
      axios.request(config)
      .then((response) => {
        // console.log(JSON.stringify(response.data), '======', i);
        if(response.data.payloads.length > 0){
          setFinboxManualData({
            kycCategory: `${allProfession[i]}`,
            response: response.data.payloads.filter((x) => x.progress === 'completed')[0]
          })
          toast({
            title: 'Finbox Report Generated Successfully',
            status: 'success',
            duration: 4000,
            isClosable: true,
            position: 'top'
          })
          setFinboxToggle(true)
          setBtnLoading(false)
        }
      })
      .catch((error) => {
        console.log(error);
        setFinboxToggle(false)
        setBtnLoading(false)
        toast({
          title: 'Oops we are facing some temporary issue with your request',
          status: 'error',
          duration: 4000,
          isClosable: true,
          position: 'top'
        })
      });
    }
    if(finboxManualData.kycCategory.length === 0) {
      setBtnLoading(false)
      toast({
        title: 'Customer not completed thier finbox process',
        status: 'warning',
        duration: 5000,
        isClosable: true,
        position: 'top'
      })
    }
  }

  //  ### finboxWebhookRes ##
  const finboxWebhookRes = () => {
    setBtnLoading(true)
    let data = JSON.stringify(finboxManualData?.response);
    
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/finbox/finbox-webhook-response`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': Auth()
      },
      data : data
    };
    
    axios.request(config)
    .then((response) => {
      console.log(JSON.stringify(response.data));
      setRenderOnCredit((prev) => prev + 1)
      setBtnLoading(false)
    })
    .catch((error) => {
      console.log(error);
      toast({
        title: `Something went wrong please try again`,
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top'
      })
      setBtnLoading(false)
    });
  }
  
  return (
    <Flex width={'80%'} flexDirection={'column'}>
      {Object.keys(adData).length > 0 ?
        <>

          <Flex p={5} pb={0} alignItems={'center'} w={'100%'} justifyContent={'space-between'}>
            <Flex>
              <Flex alignItems={'center'}>
                <BiArrowBack onClick={() => navigate(-1)} fontSize={'30px'} style={{ cursor: "pointer" }} />
                <Heading fontSize={22} ml={3}>
                  Customer Verification Details -
                  
                  <Tooltip label='Go to order'><Link to={`/orders/order/${id}`} ><Text as='span' color={'blue.500'} ml={1}>{orderData?.OrderName.includes('#') ? orderData?.OrderName : 'Draft'}</Text></Link></Tooltip> </Heading>
              </Flex>
              {((orderData?.orderStatusId === "ORDER_CREATED") || (orderData?.orderStatusId === "AWAITING_VERIFICATION")) ?
                <Box ml={6}>
                  <Button size={'sm'} colorScheme={'green'} borderRadius={'32px'} py={2} px={8} color={'white'} onClick={verifyHandler}> Verify </Button>
                  <Button size={'sm'} colorScheme={'red'} borderRadius={'32px'} py={2} px={8} color={'white'} ml={2} mr={2} onClick={declineHandler}>Decline</Button>
                </Box>
                :
                (orderData?.orderStatusId === "ORDER_CANCELED") ? <Button size={'sm'} colorScheme={'red'} cursor={'default'} ml={8}>Order Cancelled</Button> :
                  (orderData?.orderStatusId === "ORDER_DRAFT" || orderData?.orderStatusId === "ORDER_PUBLISHED") ? <Button size={'sm'} colorScheme={'cyan'} cursor={'default'} ml={8}>Draft</Button> :
                    <>
                    <Button size={'sm'} colorScheme={'green'} cursor={'default'} ml={8}>Verified</Button>
                    </>
              }
            </Flex>
            <Flex>
              <Menu>
                <MenuButton as={Button} colorScheme={'telegram'} borderRadius={'32px'} py={2} px={8} color={'white'} ml={5} size={'sm'} rightIcon={<AiOutlineDown />}>
                  Other Details
                </MenuButton>
                <MenuList>
                  <MenuItem onClick={onOpen1}>All Verification Details</MenuItem>
                  <MenuItem onClick={onOpen2}>API Logs</MenuItem>
                  <MenuItem onClick={onOpen3}>Customer Input Logs</MenuItem>
                  <MenuItem onClick={() => {
                    onOpen4()
                  }}>PAN Verification</MenuItem>
                </MenuList>
              </Menu>
            </Flex>
          </Flex>

          <Flex justifyContent={'space-evenly'} w={'100%'}>
            <Box p={5} pt={0} w={orderData?.OrderPartyBankStatement.length > 0 ? '70%' : '100%'} bgColor='#F5F5F5'>


              {/* -------- Company (Pvt Ltd.) -------- */}
              {orderData?.OrderPartyBankStatement[0]?.kycCategory === "PVT_LTD" &&
                <AdditionalDetails
                  title={"Customer"}
                  row1={[{ "Order ID": orderData?.OrderName.includes('#') ? orderData?.OrderName : 'pending' }, { "Profession": `Private Limited` }, { "GST No.": adData?.Organization.find((x) => x.organizationTypeEnumId === orderData?.OrderPartyBankStatement[0]?.kycCategory)?.gst || '----' }, { "DIN No.": adData?.PartyDetail[0]?.din || '----' }]} // no clear din gst
                  row2={[{ "Credit Score": adData?.PartyCreditScore?.filter((x) => x.verificationId === orderData?.id)[0]?.creditScore || '----' },
                  { "PAN No.": adData?.Organization.find((x) => x.organizationTypeEnumId === orderData?.OrderPartyBankStatement[0]?.kycCategory)?.panNumber || '----' },
                  { "Face Match Success": adData.PartyFaceMatch.filter((x) => x?.kycCategory === orderData?.OrderPartyBankStatement[0]?.kycCategory)[adData.PartyFaceMatch.filter((x) => x?.kycCategory === orderData?.OrderPartyBankStatement[0]?.kycCategory).length - 1]?.score || '----' },
                  // pan details object row 2 --
                  ((orderData?.orderStatusId === "ORDER_CREATED") || (orderData?.orderStatusId === "ORDER_PUBLISHED") || (orderData?.orderStatusId === "ORDER_DRAFT")) ? { "Pan No.": adData?.Organization[0]?.panNumber || '----' } : (orderData?.orderStatusId === "ORDER_CANCELED") && {}]}
                  // status details object --
                  status={[{ "customerStatus": ((orderData?.orderStatusId === "ORDER_CREATED") || (orderData?.orderStatusId === "ORDER_PUBLISHED") || (orderData?.orderStatusId === "ORDER_DRAFT")) ? 'Pending' : (orderData?.orderStatusId === "ORDER_CANCELED") ? 'Cancelled' : (orderData?.orderStatusId === "AWAITING_VERIFICATION") ? 'Awaiting' : 'Verified' }, { "verificationStatus": ((orderData?.orderStatusId === "ORDER_CREATED") || (orderData?.orderStatusId === "ORDER_PUBLISHED") || (orderData?.orderStatusId === "ORDER_DRAFT")) ? 'Pending' : (orderData?.orderStatusId === "ORDER_CANCELED") ? 'Cancelled' : (orderData?.orderStatusId === "AWAITING_VERIFICATION") ? 'Awaiting' : 'Verified' }]}
                />
              }

              {/* Done this implementation after API ready */}
              {/* ------- Skeleton -------- */}
              {/* {adData.profession === undefined && 
                    <Stack shadow={'md'} rounded={'md'} border={'1px'} borderColor={'gray.200'} bg={'white'} my={5} p={3}>
                      <Skeleton height='20px' />
                      <Skeleton height='30px' />
                      <Skeleton height='30px' />
                    </Stack>
                  } */}
              {/* -------- Student -------- */}
              
              {orderData?.OrderPartyBankStatement[0]?.kycCategory === "STUDENT" &&
                <AdditionalDetails
                  title={"Customer"}
                  row1={[{ "Order ID": orderData?.OrderName.includes('#') ? orderData?.OrderName : 'pending' }, { "Tenure ID": `#123` }, { "Profession": `Student` }]}
                  row2={[{ "Credit Score": adData?.PartyCreditScore?.filter((x) => x.verificationId === orderData?.id)[0]?.creditScore || 'n/a' },
                  { "Face Match Success": adData.PartyFaceMatch.filter((x) => x?.kycCategory === orderData?.OrderPartyBankStatement[0]?.kycCategory)[adData.PartyFaceMatch.filter((x) => x?.kycCategory === orderData?.OrderPartyBankStatement[0]?.kycCategory).length - 1]?.score || 'n/a' }]}
                  status={[{ "customerStatus": ((orderData?.orderStatusId === "ORDER_CREATED") || (orderData?.orderStatusId === "ORDER_PUBLISHED") || (orderData?.orderStatusId === "ORDER_DRAFT")) ? 'Pending' : (orderData?.orderStatusId === "ORDER_CANCELED") ? 'Cancelled' : (orderData?.orderStatusId === "AWAITING_VERIFICATION") ? 'Awaiting' : 'Verified' }, { "verificationStatus": ((orderData?.orderStatusId === "ORDER_CREATED") || (orderData?.orderStatusId === "ORDER_PUBLISHED") || (orderData?.orderStatusId === "ORDER_DRAFT")) ? 'Pending' : (orderData?.orderStatusId === "ORDER_CANCELED") ? 'Cancelled' : (orderData?.orderStatusId === "AWAITING_VERIFICATION") ? 'Awaiting' : 'Verified' }]}
                />
              }

              {/* -------- Working Professional -------- */}
              {orderData?.OrderPartyBankStatement[0]?.kycCategory === "WORK_PROF" &&
                <>
                  <AdditionalDetails
                    title={"Customer"}
                    row1={[{ "Order ID": orderData?.OrderName.includes('#') ? orderData?.OrderName : 'pending' }, { "Tenure ID": `#123` }, { "Profession": `Working Professional` }, { "Work Email ID": `${adData?.PartyDetail[adData?.PartyDetail.length - 1]?.workEmail}` }]}
                    row2={[{ "Credit Score": adData?.PartyCreditScore?.filter((x) => x.verificationId === orderData?.id)[0]?.creditScore || 'n/a' },
                    { "Face Match Success": adData.PartyFaceMatch.filter((x) => x?.kycCategory === orderData?.OrderPartyBankStatement[0]?.kycCategory)[adData.PartyFaceMatch.filter((x) => x?.kycCategory === orderData?.OrderPartyBankStatement[0]?.kycCategory).length - 1]?.score || 'n/a' }]}
                    status={[{ "customerStatus": ((orderData?.orderStatusId === "ORDER_CREATED") || (orderData?.orderStatusId === "ORDER_PUBLISHED") || (orderData?.orderStatusId === "ORDER_DRAFT")) ? 'Pending' : (orderData?.orderStatusId === "ORDER_CANCELED") ? 'Cancelled' : (orderData?.orderStatusId === "AWAITING_VERIFICATION") ? 'Awaiting' : 'Verified' }, { "verificationStatus": ((orderData?.orderStatusId === "ORDER_CREATED") || (orderData?.orderStatusId === "ORDER_PUBLISHED") || (orderData?.orderStatusId === "ORDER_DRAFT")) ? 'Pending' : (orderData?.orderStatusId === "ORDER_CANCELED") ? 'Cancelled' : (orderData?.orderStatusId === "AWAITING_VERIFICATION") ? 'Awaiting' : 'Verified' }]}
                  />
                </>
              }

              {/* -------- Company (Partnership) -------- organization pan for this order based filter ---*/}
              {orderData?.OrderPartyBankStatement[0]?.kycCategory === "PARTNERSHIP_FIRM" &&
                <>
                  <AdditionalDetails
                    title={"Customer"}
                    row1={[{ "Order ID": orderData?.OrderName.includes('#') ? orderData?.OrderName : 'pending' }, { "Tenure ID": `#123` }, { "Profession": `Partnership` }, { "Pan No.": adData?.PartyPanKyc?.find((x) => x?.kycCategory === orderData?.OrderPartyBankStatement[0]?.kycCategory)?.panDetail?.panNumber }, { "Company PAN No.": adData?.Organization.find((x) => x.organizationTypeEnumId === orderData?.OrderPartyBankStatement[0]?.kycCategory)?.panNumber }]}
                    row2={[{ "GST No.": adData?.Organization.find((x) => x.organizationTypeEnumId === orderData?.OrderPartyBankStatement[0]?.kycCategory)?.gst || 'n/a' },
                    { "Credit Score": adData?.PartyCreditScore?.filter((x) => x.verificationId === orderData?.id)[0]?.creditScore || 'n/a' },
                    { "Face Match Success": adData.PartyFaceMatch.filter((x) => x?.kycCategory === orderData?.OrderPartyBankStatement[0]?.kycCategory)[adData.PartyFaceMatch.filter((x) => x?.kycCategory === orderData?.OrderPartyBankStatement[0]?.kycCategory).length - 1]?.score || 'n/a' }]}
                    status={[{ "customerStatus": ((orderData?.orderStatusId === "ORDER_CREATED") || (orderData?.orderStatusId === "ORDER_PUBLISHED") || (orderData?.orderStatusId === "ORDER_DRAFT")) ? 'Pending' : (orderData?.orderStatusId === "ORDER_CANCELED") ? 'Cancelled' : (orderData?.orderStatusId === "AWAITING_VERIFICATION") ? 'Awaiting' : 'Verified' }, { "verificationStatus": ((orderData?.orderStatusId === "ORDER_CREATED") || (orderData?.orderStatusId === "ORDER_PUBLISHED") || (orderData?.orderStatusId === "ORDER_DRAFT")) ? 'Pending' : (orderData?.orderStatusId === "ORDER_CANCELED") ? 'Cancelled' : (orderData?.orderStatusId === "AWAITING_VERIFICATION") ? 'Awaiting' : 'Verified' }]}
                  />
                </>
              }

              <Flex widht="100%" justifyContent={'flex-start'} flexDirection={'column'} mt={6}>
                  {(finboxToggle === false) && <Button colorScheme={'facebook'} onClick={getProfession} isLoading={btnLoading}>Get Profession</Button>}
                  <Flex>
                  {finboxToggle && 
                    <Flex flexDirection={'column'} width={'100%'}>
                     {finboxToggle && <Text fontWeight={'semibold'} mb={2}>Profession : {finboxManualData?.kycCategory}</Text>}
                      <Button colorScheme={'green'} isLoading={btnLoading} onClick={finboxWebhookRes}>Generate Finbox Report</Button>
                    </Flex>
                  }
                  </Flex>
              </Flex>
              {/* -------- Company (Pvt Ltd.) -------- */}
              {/* { adData?.PartyFaceMatch.find((x) => x.verificationId === orderData?.id)?.kycCategory === "PVT_LTD"  &&
                  <>
                  <AdditionalDetails
                      title={"Customer"}
                      row1={[{"Order ID":`${adData?.order_id}`},{"Tenure ID":`${adData?.tenure_id}`},{"Profession":`${adData?.profession}`},{"Pan No.":`${adData?.pan_no}`},{"GST No.": `${adData?.gst_no}`}]}
                      row2={[{"DIN No.":`${adData?.din_no}`},{"Face Match Success": `${adData?.face_match_success}`}]}
                      status={[{customerStatus: `${adData?.customer_status}`},{verificationStatus: `${adData?.verification_status}`}]}
                      />
                  </>
                  } */}
                <>
                  <CustomerDetails cData={adData} orderData={orderData} renderXyz={renderXyz}  kycCategory={orderData?.OrderPartyBankStatement[0]?.kycCategory} pvtPan={adData?.Organization.find((x) => x.organizationTypeEnumId === orderData?.OrderPartyBankStatement[0]?.kycCategory)?.panNumber || null} showBox={true} />
                  <DocumentAttached paryData={adData} verified={isVerified} hideStatus={orderData?.orderStatusId} />
                </>
              {/* {orderData?.OrderPartyBankStatement.length > 0 ?
                <>
                  <CustomerDetails cData={adData} orderData={orderData} renderXyz={renderXyz}  kycCategory={orderData?.OrderPartyBankStatement[0]?.kycCategory} pvtPan={adData?.Organization.find((x) => x.organizationTypeEnumId === orderData?.OrderPartyBankStatement[0]?.kycCategory)?.panNumber || null} showBox={true} />
                  <DocumentAttached paryData={adData} verified={isVerified} hideStatus={orderData?.orderStatusId} />
                </>
                :
                <Flex widht="100%" justifyContent={'flex-start'} flexDirection={'column'} mt={6}>
                  {(finboxToggle === false) && <Button colorScheme={'facebook'} onClick={getProfession} isLoading={btnLoading}>Get Profession</Button>}
                  <Flex>
                  {finboxToggle && 
                    <Flex flexDirection={'column'} width={'100%'}>
                     {finboxToggle && <Text fontWeight={'semibold'} mb={2}>Profession : {finboxManualData?.kycCategory}</Text>}
                      <Button colorScheme={'green'} isLoading={btnLoading} onClick={finboxWebhookRes}>Generate Finbox Report</Button>
                    </Flex>
                  }
                  </Flex>
                </Flex>
              } */}

       
            </Box>
            {/* {orderData?.OrderPartyBankStatement.length > 0 && */}
              <Box pr={3} py={3} pt={0} w={'30%'} bgColor='#F5F5F5'>
                <RightSidebar
                  customerName={orderData.customerParty?.firstName + ' ' + orderData.customerParty?.lastName}
                  customerGmail={orderData.customerParty?.email}
                  customerPhone={orderData.customerParty?.phone}
                  shippingArea={orderData.shippingAddress}
                  shippingCity={orderData.shippingAddress?.city}
                  billingAddress={orderData.billingAddress}
                  party={adData}
                />
              </Box>
            {/* } */}
          </Flex>
        </>
        :
        <Flex width={'100%'} height={'100px'} justifyContent={'center'} alignItems={'center'}>
          <Spinner
            thickness='4px'
            speed='0.65s'
            emptyColor='gray.200'
            color='blue.500'
            size='xl'
          />
        </Flex>

      }



      {/* Verificatio details modal */}
      <Modal isOpen={isOpen1} onClose={onClose1} size={'4xl'}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader margin={'auto'}>All Verification Details</ModalHeader>
          <ModalCloseButton />

          {Object.keys(adData).length > 0 &&
            <ModalBody>
              <>
                <Flex>
                  <Text fontWeight={'semibold'} color={'gray.600'}>All PAN KYC DETAILS {adData?.PartyPanKyc.length === 0 && <Text as='span' ml={2} color={'red.700'}>(NO DATA AVAILABLE)</Text>}</Text>
                </Flex>
                <Divider size={1} borderBottomColor={'black'} my={2} />
                <TableContainer>
                  <Table variant='striped'>

                    {/* Pan Details */}
                    <Thead>
                      <Tr>
                        <Th>S.No</Th>
                        <Th>KYC Status</Th>
                        <Th>Full Name</Th>
                        <Th>Linked Number</Th>
                        <Th>Profession</Th>

                      </Tr>
                    </Thead>
                    <Tbody overflow="hidden" whiteSpace="pre-wrap" textAlign={'left'}>
                      {adData?.PartyPanKyc.map((x, ix) => {
                        return (
                          <Fragment key={ix}>
                            <Tr >
                              <Td>
                                <span>{ix + 1}</span>
                              </Td>
                              <Td>
                                <span>{x?.statusId || '----'}</span>
                              </Td>
                              <Td>
                                <span>{x?.panDetail?.fullName || '----'}</span>
                              </Td>
                              <Td>
                                <span>{x?.panDetail?.linkedMobileNumber || '----'}</span>
                              </Td>
                              <Td>
                                <span>{x?.kycCategory || '----'}</span>
                              </Td>
                            </Tr>
                          </Fragment>
                        )
                      })}
                      {/* Pan end --- */}
                    </Tbody>
                  </Table>
                </TableContainer>
                <Divider size={1} borderBottomColor={'black'} my={4} />

                {/* ------ facematch -------- */}
                <Flex>
                  <Text fontWeight={'semibold'} color={'gray.600'}>All FACE MATCH DETAILS {adData?.PartyFaceMatch.length === 0 && <Text as='span' ml={2} color={'red.700'}>(NO DATA AVAILABLE)</Text>}</Text>
                </Flex>
                <Divider size={1} borderBottomColor={'black'} my={2} mt={4} />
                <TableContainer>
                  <Table variant='striped'>

                    {/* Pan Details */}
                    <Thead>
                      <Tr>
                        <Th>S.No</Th>
                        <Th>Status</Th>
                        <Th>Match Percentage</Th>
                        <Th>Profession</Th>
                        <Th>Match Date</Th>
                      </Tr>
                    </Thead>
                    <Tbody overflow="hidden" whiteSpace="pre-wrap" textAlign={'left'}>
                      {adData?.PartyFaceMatch.map((z, i) => {
                        return (
                          <Fragment key={i}>
                            <Tr>
                              <Td>
                                <span>{i + 1}</span>
                              </Td>
                              <Td>
                                <span>{z?.decentroStatus !== null ? z?.decentroStatus === "VERIFIED" ? "SUCCESS" : z?.decentroStatus : '----'}</span>
                              </Td>
                              <Td>
                                <span>{z?.score || '----'}</span>
                              </Td>
                              <Td>
                                <span>{z?.kycCategory || '---'}</span>
                              </Td>
                              <Td>
                                <span>{new Date(z?.matchDate).toLocaleDateString('IN') || '---'}</span>
                              </Td>
                            </Tr>

                          </Fragment>
                        )
                      })}
                    </Tbody>
                  </Table>
                </TableContainer>
                <Divider size={1} borderBottomColor={'black'} my={4} />


                {/* Credit report variables  */}
                <Flex>
                  <Text fontWeight={'semibold'} color={'gray.600'}>ALL CREDIT REPORT {adData?.PartyCreditScore.length === 0 && <Text as='span' ml={2} color={'red.700'}>(NO DATA AVAILABLE)</Text>}</Text>
                </Flex>
                <Divider size={1} borderBottomColor={'black'} my={2} mt={4} />
                <TableContainer>
                  <Table variant='striped'>

                    {/* Pan Details */}
                    <Thead>
                      <Tr>
                        <Th>S.No</Th>
                        <Th>Score Details</Th>
                        <Th>Comment</Th>
                      </Tr>
                    </Thead>
                    <Tbody overflow="hidden" whiteSpace="pre-wrap" textAlign={'left'}>
                      {adData.PartyCreditScore.map((k, ik) => {
                        return (
                          <Fragment key={ik}>
                            <Tr>
                              <Td>
                                <span>{ik + 1}</span>
                              </Td>
                              <Td>
                                <span>{k?.creditScore || "----"}</span>
                              </Td>
                              <Td>
                                <span>{k?.comment || "----"}</span>
                              </Td>
                            </Tr>

                          </Fragment>
                        )
                      })}
                    </Tbody>
                  </Table>
                </TableContainer>
                <Divider size={1} borderBottomColor={'black'} my={4} />

                {/* RENTAL ACCOUNT DETAILS */}
                <Flex>
                  <Text fontWeight={'semibold'} color={'gray.600'}>ALL RETAIL ACCOUNT DETAILS {adData?.BankAccount.length === 0 && <Text as='span' ml={2} color={'red.700'}>(NO DATA AVAILABLE)</Text>}</Text>
                </Flex>
                <Divider size={1} borderBottomColor={'black'} my={2} mt={4} />
                <TableContainer>
                  <Table variant='striped'>

                    {/* Pan Details */}
                    <Thead>
                      <Tr>
                        <Th>S.No</Th>
                        <Th>Retail Account Details</Th>
                      </Tr>
                    </Thead>
                    <Tbody overflow="hidden" whiteSpace="pre-wrap" textAlign={'left'}>
                      {adData?.BankAccount?.map((bank, i) => {
                        return (
                          <Fragment key={i}>
                            <Tr >
                              <Td>{i + 1}</Td>
                              <Td>
                                <span>Institution: {bank?.institution || '----'}</span>
                                <br />
                                <span>Account Type: {bank?.decentroAccountType || '----'}</span>
                                <br />
                                <span>Credit Limit: {bank?.creditLimit || 'N/A , data not getting form from Decentro'}</span>
                                <br />
                                {/* <span>Sanction Amount: {bank?.sanctionAmount || 'N/A , data not getting form from Decentro'}</span>
                      <br /> */}
                                <span>Date Opened: {bank?.dateOpened || '----'}</span>
                              </Td>
                            </Tr>

                          </Fragment>
                        )
                      })}
                    </Tbody>
                  </Table>
                </TableContainer>

                <Divider size={1} borderBottomColor={'black'} my={4} />
                {/* GST DETAILS */}
                <Flex>
                  <Text fontWeight={'semibold'} color={'gray.600'}>GST DETAILS {gstInfo?.length === 0 && <Text as='span' ml={2} color={'red.700'}>(NO DATA AVAILABLE)</Text>}</Text>
                </Flex>
                <Divider size={1} borderBottomColor={'black'} my={4} />
                <TableContainer>
                  <Table variant='striped'>
                    <Thead>
                      <Tr>
                        <Th>S.No</Th>
                        <Th>INFO</Th>
                        <Th>RESULT</Th>
                      </Tr>
                    </Thead>
                    <Tbody overflow="hidden" whiteSpace="pre-wrap" textAlign={'left'}>
                    {gstInfo?.length > 0 &&
                    <>
                      <Tr>
                        <Td>1.</Td>
                        <Td>KYC Status</Td>
                        <Td>{gstInfo[0]?.kycStatus || 'n/a'}</Td>
                      </Tr>
                      <Tr>
                        <Td>2.</Td>
                        <Td>Address</Td>
                        <Td>{gstInfo[0]?.address || 'n/a'}</Td>
                      </Tr>
                      <Tr>
                        <Td>3.</Td>
                        <Td>Nature of business at address</Td>
                        <Td>{gstInfo[0]?.natureOfBusinessAtAddress || 'n/a'}</Td>
                      </Tr>
                      <Tr>
                        <Td>4.</Td>
                        <Td>Registered date</Td>
                        <Td>{gstInfo[0]?.natureOfBusinessAtAddress || 'n/a'}</Td>
                      </Tr>
                      <Tr>
                        <Td>5.</Td>
                        <Td>Trade name</Td>
                        <Td>{gstInfo[0]?.tradeName || 'n/a'}</Td>
                      </Tr>
                      <Tr>
                        <Td>6.</Td>
                        <Td>GSTIN</Td>
                        <Td>{gstInfo[0]?.gstNumber || 'n/a'}</Td>
                      </Tr>
                      <Tr>
                        <Td>7.</Td>
                        <Td>Directors</Td>
                        <Td>{gstInfo[0]?.directorsList || 'n/a'}</Td>
                      </Tr>
                      <Tr>
                        <Td>8.</Td>
                        <Td>Annual aggregate turnover</Td>
                        <Td>{gstInfo[0]?.annualAggregateTurnover || 'n/a'}</Td>
                      </Tr>



                      {/* loop */}
                      <Tr>
                        <Td>9.</Td>
                        <Td>{`Filling Status`}</Td>
                        <Td>
                          {gstInfo[0]?.GstFiling.map((gstFilling, index) => {
                            return (
                              <Fragment key={index}>
                                <Box >
                                  <span>Filing Date: {gstFilling?.filingDate || 'n/a'}</span>
                                  <br />
                                  <span>Filing For Month: {gstFilling?.filingForMonth || 'n/a'}</span>
                                  <br />
                                  <span>Filing Annual Return: {gstFilling?.filingAnnualReturn || 'n/a'}</span>
                                  <br />
                                  <span>Filing Status: {gstFilling?.filingStatus || "n/a"}</span>
                                  <br />
                                  <span>Filing Gst Type: {gstFilling?.filingGstType || "n/a"}</span>
                                </Box>
                                <Divider size={1} borderBottomColor={'black'} my={4} />
                              </Fragment>
                            )
                          })}
                        </Td>
                      </Tr>
                      </>
                    }
                    </Tbody>
                  </Table>
                </TableContainer>

                <Divider size={1} borderBottomColor={'black'} my={2} mt={4} />

                {/* DIN DETAILS */}
                <Flex>
                  <Text fontWeight={'semibold'} color={'gray.600'}>DIN DETAILS {adData?.BankAccount.length === 0 && <Text as='span' ml={2} color={'red.700'}>(NO DATA AVAILABLE)</Text>}</Text>
                </Flex>
                <Divider size={1} borderBottomColor={'black'} my={2} mt={4} />
                <TableContainer>
                  <Table variant='striped'>
                    <Thead>
                      <Tr>
                        <Th>S.No</Th>
                        <Th>INFO</Th>
                        <Th>RESULT</Th>
                      </Tr>
                    </Thead>
                    <Tbody overflow="hidden" whiteSpace="pre-wrap" textAlign={'left'}>
                      {Object.keys(dinInfo).length > 0 &&
                        <>
                          <Tr>
                            <Td>2.</Td>
                            <Td>DIN</Td>
                            <Td>{dinInfo?.dinNumber || 'n/a'}</Td>
                          </Tr>
                          <Tr>
                            <Td>3.</Td>
                            <Td>Director</Td>
                            <Td>{dinInfo?.directorName || 'n/a'}</Td>
                          </Tr>

                          {/* loop */}
                          <Tr>
                          <Td>4.</Td>
                          <Td>{`Companies`}</Td>
                          <Td>
                          {dinInfo.companies.map((gstFilling, index) => {
                            return (
                              <Box key={index}>
                                <Text><Text as={'span'}>{index + 1}. </Text>{gstFilling || 'n/a'}</Text>
                                <Divider size={1} borderBottomColor={'black'} my={4} />
                              </Box>
                            )
                          })}
                          </Td>
                          </Tr>
                        </>
                      }

                    </Tbody>
                  </Table>
                </TableContainer>

              </>
            </ModalBody>
          }
          <ModalFooter w={'full'}>
            <Button colorScheme='blue' mx={3} onClick={onClose1} width={'100%'}>
              Close
            </Button>

          </ModalFooter>
        </ModalContent>
      </Modal>


      {/* ####### Order Journey Details ############  */}
      <Modal isOpen={isOpen2} onClose={onClose2} size={'6xl'}>
        <ModalOverlay />
        <ModalContent width={'100%'}>
          <ModalHeader margin={'auto'}>API Logs</ModalHeader>
          <ModalCloseButton />

          {journeyDetails.length > 0 ?
            <ModalBody >
              <>
                <TableContainer>
                  <Table variant='striped'>
                    <Thead>
                      <Tr>
                        <Th>S.No</Th>
                        <Th>Category</Th>
                        <Th>Comment</Th>
                        <Th>Created At</Th>
                      </Tr>
                    </Thead>
                    <Tbody overflow="hidden" whiteSpace="pre-wrap" textAlign={'left'}>
                      {journeyDetails?.map((x, i) => {
                        return (
                          <Fragment key={i}>
                            <Tr>
                              <Td>
                                <Text as={'span'} >{i + 1}</Text>
                              </Td>
                              <Td>
                                <Text as={'span'}>{x?.category || "---"}</Text>
                              </Td>
                              <Td >
                                <Text as="span" wordBreak={'break-all'}>{x?.comment || "----"}</Text>
                              </Td>
                              <Td>
                                <span>{formatDate(new Date(x?.createdAt)) || "---"}</span>
                              </Td>
                            </Tr>
                          </Fragment>
                        )

                      })}
                    </Tbody>
                  </Table>
                </TableContainer>
              </>
            </ModalBody>
            :
            <ModalBody >
              <Flex justifyContent={'center'} w={'100%'}>
                <Text color={'red.700'}>No Journey Details found</Text>
              </Flex>
            </ModalBody>
          }
          <ModalFooter w={'full'}>
            <Button colorScheme='blue' mx={3} onClick={onClose2} width={'100%'}>
              Close
            </Button>

          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* ####### Customer Journey Details ############  */}
      <Modal isOpen={isOpen3} onClose={onClose3} size={'6xl'}>
        <ModalOverlay />
        <ModalContent width={'100%'}>
          <ModalHeader margin={'auto'}>Customer Input Logs</ModalHeader>
          <ModalCloseButton />

          {customerJourneyDetails.length > 0 ?
            <ModalBody >
              <>
                <TableContainer>
                  <Table variant='striped'>
                    <Thead>
                      <Tr>
                        <Th>S.No</Th>
                        <Th>Category</Th>
                        <Th>Comment</Th>
                        <Th>Created At</Th>
                      </Tr>
                    </Thead>
                    <Tbody overflow="hidden" whiteSpace="pre-wrap" textAlign={'left'}>
                      {customerJourneyDetails?.map((x, i) => {
                        return (
                          <Fragment key={i}>
                            <Tr>
                              <Td>
                                <Text as={'span'} >{i + 1}</Text>
                              </Td>
                              <Td>
                                <Text as={'span'}>{x?.category || "---"}</Text>
                              </Td>
                              <Td >
                                <Text as="span" wordBreak={'break-all'}>{x?.comment || "----"}</Text>
                              </Td>
                              <Td>
                                <span>{formatDate(new Date(x?.createdAt)) || "---"}</span>
                              </Td>
                            </Tr>
                          </Fragment>
                        )

                      })}
                    </Tbody>
                  </Table>
                </TableContainer>
              </>
            </ModalBody>
            :
            <ModalBody >
              <Flex justifyContent={'center'} w={'100%'}>
                <Text color={'red.700'}>No Journey Details found</Text>
              </Flex>
            </ModalBody>
          }
          <ModalFooter w={'full'}>
            <Button colorScheme='blue' mx={3} onClick={onClose2} width={'100%'}>
              Close
            </Button>

          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* ### PAN VERIFICATION ###  */}
      <Modal isOpen={isOpen4} onClose={onClose4} size={'6xl'}>
        <ModalOverlay />
        <ModalContent width={'100%'}>
          <ModalHeader margin={'auto'}>PAN VERIFICATION</ModalHeader>
          <ModalCloseButton />
          <ModalBody >
            <PanVerification kycCategory={orderData?.OrderPartyBankStatement?.length > 0 ? orderData?.OrderPartyBankStatement[0]?.kycCategory : finboxManualData?.kycCategory} partyId={orderData?.customerPartyId} onClose4={onClose4} />
          </ModalBody>
          <ModalFooter w={'full'}>
            {/* <Button colorScheme='blue' mx={3} onClick={onClose4} width={'100%'}>
              Close
            </Button>
            <Button colorScheme='blue' mx={3} onClick={onClose4} width={'100%'} ml={2}>
              Verifiy
            </Button> */}

          </ModalFooter>
        </ModalContent>
      </Modal>

    </Flex>
  )
}

export default VerifcationDetails
